import SalarieNomNaissance from '@/generated/controls/salarie/SalarieNomNaissance.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: SalarieNomNaissance
})
